import { Col, Row, Typography } from 'antd';
import { DocumentCard } from 'features/Dashboard/ui/DocumentCard';
import { Fragment } from 'react';

export const ThirdSubCategory = ({
  thirdCategoryData,
  setCategoryList,
  setShowSubCategory,
  subCategoryName,
  setShowSecondCategory,
  setShowSubSecondCategory,
  setCommentsInfo,
  setAddCommentsModal,
  // subCategoryDocument,
  secondCategoryDocument,
  setShowSubThirdCategory,
  setShowThirdCategory,
}: any) => {
  const showCategory = () => {
    setCategoryList(true);
    setShowSubCategory(false);
    setShowSecondCategory(false);
    setShowSubSecondCategory(false);
    setShowThirdCategory(false);
    setShowSubThirdCategory(false);
  };
  const showSubCatgoryDocument = () => {
    setCategoryList(false);
    setShowSubCategory(true);
    setShowSecondCategory(false); //
    setShowSubSecondCategory(true);
    setShowThirdCategory(false);
    setShowSubThirdCategory(true);
  };
  const showSubThirdCatgoryDocuments = () => {
    setShowThirdCategory(false);
    setShowSubThirdCategory(true);
  };
  const handleAddComment = (document: any) => {
    setAddCommentsModal(true);
    setCommentsInfo(document);
  };

  return (
    <Fragment>
      <Typography className='ctgrybx'>
        <ul>
          <li>
            <a href='javascript:void();' onClick={() => showCategory()}>
              Categories
            </a>
          </li>
          <li>
            <a
              href='javascript:void()'
              onClick={() => showSubCatgoryDocument()}
            >
              {subCategoryName}
            </a>{' '}
          </li>
          <li>
            <a
              href='javascript:void()'
              onClick={() => showSubThirdCatgoryDocuments()}
            >
              {secondCategoryDocument.subCategory}
            </a>
          </li>
          <li>{thirdCategoryData?.classCategory}</li>
        </ul>
      </Typography>
      <Row gutter={[16, 16]} justify='start' align='top' className='mb-4'>
        {Array.isArray(thirdCategoryData.documentList) &&
        thirdCategoryData.documentList.length
          ? thirdCategoryData.documentList?.map((item: any, index: number) => (
              <Col
                key={index}
                xxl={6}
                xl={8}
                lg={8}
                md={12}
                sm={24}
                role='button'
                className='self-stretch'
              >
                <DocumentCard document={item} onAddComment={handleAddComment} />
              </Col>
            ))
          : ''}
      </Row>
    </Fragment>
  );
};
